/**
 * All the setters for the superpaper
 */
import config from '../config.json'
import {
     message
} from 'antd';

var SUPERAPI_PREFIX= config['superpaper_api_host']+config['api_v']

export async function UploadData(data){
    try {
        var response = await fetch(SUPERAPI_PREFIX+"/upload", {
            method: 'POST',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        // console.log(response)
        if(response.ok){
            const content = await response.json();
            message.success("Data saved successfully!")
            return true
        }
        else{
            message.error('Oops! Error in upload')
        }
        
    } catch (error) {
        message.error('Oops! Error in upload')
        return false
    }
    
}